jQuery(document).ready(function ($) {
    var $root = $('[data-shoutbox]');

    if (!$root.length || typeof oddsnetShoutbox === 'undefined') {
        return;
    }

    var config = oddsnetShoutbox;
    var autoLimitOn = !(config.autoLimit === false || config.autoLimit === '' || config.autoLimit === 0 || config.autoLimit === '0');
    var loadMoreOn = !!(config.loadMore && config.loadMore !== '0');
    var storageSeen = 'oddsnet_shoutbox_last_seen_id';
    var storageCollapsedMobile = 'oddsnet_shoutbox_collapsed';
    var storageCollapsedDesktop = 'oddsnet_shoutbox_collapsed_desktop';
    var mobileQuery = window.matchMedia('(max-width: 1438px)');
    var pollTimer = null;
    var sending = false;
    var composeLocked = false;
    var unlockTimer = null;

    var $toggle = $root.find('[data-shoutbox-toggle]');
    var $launcher = $root.find('.shoutbox-launcher');
    var $panel = $root.find('[data-shoutbox-panel]');
    var $unread = $root.find('[data-shoutbox-unread]');
    var $messages = $root.find('[data-shoutbox-messages]');
    var $form = $root.find('[data-shoutbox-form]');
    var $input = $root.find('[data-shoutbox-input]');
    var $counter = $root.find('[data-shoutbox-counter]');
    var $send = $root.find('[data-shoutbox-send]');
    var $error = $root.find('[data-shoutbox-error]');
    var $emojiToggle = $root.find('[data-shoutbox-emoji-toggle]');
    var $emojiPicker = $root.find('[data-shoutbox-emoji-picker]');
    var $loadMore = $root.find('[data-shoutbox-load-more]');
    var loadingMore = false;
    var historyExpanded = false;
    var graphemeSegmenter = (typeof Intl !== 'undefined' && typeof Intl.Segmenter === 'function')
        ? new Intl.Segmenter(undefined, { granularity: 'grapheme' })
        : null;

    function graphemes(text) {
        text = text || '';

        if (!text) {
            return [];
        }

        if (graphemeSegmenter) {
            return Array.from(graphemeSegmenter.segment(text), function (item) {
                return item.segment;
            });
        }

        return Array.from(text);
    }

    function characterCount(text) {
        return graphemes(text).length;
    }

    function truncateGraphemes(text, max) {
        var parts = graphemes(text);

        if (parts.length <= max) {
            return text || '';
        }

        return parts.slice(0, max).join('');
    }

    function isMobile() {
        return mobileQuery.matches;
    }

    function latestId() {
        return parseInt($root.attr('data-latest-id'), 10) || 0;
    }

    function oldestId() {
        return parseInt($root.attr('data-oldest-id'), 10) || 0;
    }

    function syncOldestId() {
        var oldest = 0;

        $messages.find('[data-message-id]').each(function () {
            var id = parseInt($(this).attr('data-message-id'), 10) || 0;

            if (id && (!oldest || id < oldest)) {
                oldest = id;
            }
        });

        $root.attr('data-oldest-id', String(oldest));
        return oldest;
    }

    function setLoadMoreVisible(visible) {
        if (!$loadMore.length) {
            return;
        }

        $loadMore.prop('hidden', !visible);
    }

    function lastSeenId() {
        return parseInt(window.localStorage.getItem(storageSeen), 10) || 0;
    }

    function setLastSeen(id) {
        window.localStorage.setItem(storageSeen, String(id || 0));
    }

    function setCollapsed(collapsed) {
        $root.toggleClass('is-collapsed', collapsed);
        $root.toggleClass('is-expanded', !collapsed);
        $toggle.attr('aria-expanded', collapsed ? 'false' : 'true');

        if (isMobile()) {
            window.localStorage.setItem(storageCollapsedMobile, collapsed ? '1' : '0');
        } else {
            window.localStorage.setItem(storageCollapsedDesktop, collapsed ? '1' : '0');
        }

        if (!collapsed) {
            setLastSeen(latestId());
            updateUnread(0);
            closeEmoji();
        }

        updateShoutboxOffset();
    }

    function updateUnread(count) {
        var value = Math.max(0, parseInt(count, 10) || 0);

        if (value > 99) {
            $unread.text('99+');
        } else {
            $unread.text(String(value));
        }

        $unread.prop('hidden', value < 1);
    }

    function unreadFromDom() {
        if (!$root.hasClass('is-collapsed')) {
            return 0;
        }

        var seen = lastSeenId();
        var count = 0;

        $messages.find('[data-message-id]').each(function () {
            if (parseInt($(this).attr('data-message-id'), 10) > seen) {
                count += 1;
            }
        });

        return count;
    }

    function initialCollapsed() {
        if (!isMobile()) {
            return window.localStorage.getItem(storageCollapsedDesktop) === '1';
        }

        var stored = window.localStorage.getItem(storageCollapsedMobile);

        if (stored === null) {
            return true;
        }

        return stored === '1';
    }

    function updateCounter() {
        if (!$input.length) {
            return;
        }

        var max = parseInt($root.attr('data-max-chars'), 10) || config.maxChars || 200;
        var value = $input.val() || '';
        var length = characterCount(value);

        if (length > max) {
            value = truncateGraphemes(value, max);
            $input.val(value);
            length = max;
        }

        $counter.text(length + '/' + max);
        $counter.toggleClass('is-limit', length >= max);
        $send.prop('disabled', composeLocked || length < 1 || length > max || sending);
        $input.prop('disabled', composeLocked);
        $emojiToggle.prop('disabled', composeLocked);
    }

    function setComposeLocked(locked, message, retryAfter) {
        composeLocked = !!locked;
        $form.toggleClass('is-blocked', composeLocked);

        if (unlockTimer) {
            window.clearTimeout(unlockTimer);
            unlockTimer = null;
        }

        if (composeLocked) {
            closeEmoji();
            $input.prop('disabled', true);
            $emojiToggle.prop('disabled', true);
            $send.prop('disabled', true);
            showError(message || 'Du sender for mange meldinger. Vent litt og prøv igjen.');

            var wait = Math.max(1, parseInt(retryAfter, 10) || 600) * 1000;
            unlockTimer = window.setTimeout(function () {
                setComposeLocked(false);
            }, wait);
            return;
        }

        $input.prop('disabled', false);
        $emojiToggle.prop('disabled', false);
        showError('');
        updateCounter();
    }

    function showError(message) {
        if (!message) {
            $error.prop('hidden', true).text('');
            return;
        }

        $error.text(message).prop('hidden', false);
    }

    function escapeHtml(value) {
        return $('<div>').text(value || '').html();
    }

    function messageHtml(item) {
        var author = item.author_html
            ? item.author_html
            : '<span class="shoutbox__author-name"' + (item.name_color ? ' style="color:' + escapeHtml(item.name_color) + '"' : '') + '>' + escapeHtml(item.display_name) + '</span>';

        return (
            '<article class="shoutbox__message" data-message-id="' + escapeHtml(String(item.id)) + '">' +
                '<div class="shoutbox__message-heading">' +
                    author +
                    '<time class="shoutbox__time" datetime="' + escapeHtml(item.created_at) + '">' + escapeHtml(item.time_label) + '</time>' +
                '</div>' +
                '<p class="shoutbox__text">' + escapeHtml(item.message) + '</p>' +
            '</article>'
        );
    }

    function prependMessages(items, incrementUnread) {
        if (!items || !items.length) {
            return;
        }

        $messages.find('[data-shoutbox-empty]').remove();

        var currentLatest = latestId();
        var html = '';
        var added = 0;

        items.forEach(function (item) {
            if (!item || !item.id || $messages.find('[data-message-id="' + item.id + '"]').length) {
                return;
            }

            html += messageHtml(item);
            added += 1;

            if (item.id > currentLatest) {
                currentLatest = item.id;
            }
        });

        if (!html) {
            return;
        }

        $messages.prepend(html);

        // After Load more, keep the expanded history. Auto-limit only trims
        // the initial window before the user has fetched older messages.
        if (autoLimitOn && !historyExpanded) {
            $messages.find('.shoutbox__message').slice(config.maxMessages || 20).remove();
        }

        $root.attr('data-latest-id', String(currentLatest));
        syncOldestId();

        if (incrementUnread && $root.hasClass('is-collapsed')) {
            updateUnread(unreadFromDom());
        } else if (!$root.hasClass('is-collapsed')) {
            setLastSeen(currentLatest);
            updateUnread(0);
        }
    }

    function closeEmoji() {
        $emojiPicker.prop('hidden', true);
        $emojiToggle.attr('aria-expanded', 'false');
    }

    function insertEmoji(emoji) {
        if (!$input.length || composeLocked) {
            return;
        }

        var field = $input.get(0);
        var max = parseInt($root.attr('data-max-chars'), 10) || config.maxChars || 200;
        var value = $input.val() || '';
        var start = field.selectionStart || value.length;
        var end = field.selectionEnd || value.length;
        var next = value.slice(0, start) + emoji + value.slice(end);

        if (characterCount(next) > max) {
            next = truncateGraphemes(next, max);
        }

        $input.val(next);
        updateCounter();
        $input.focus();
    }

    function updateShoutboxOffset() {
        var offset = '0px';

        if (isMobile() && $root.hasClass('is-collapsed')) {
            var extra = $launcher.hasClass('shoutbox-launcher--short') || $launcher.hasClass('shoutbox-launcher--megaphone') ? 16 : 0;
            offset = Math.ceil(($launcher.outerHeight() || 56) + extra) + 'px';
        }

        document.documentElement.style.setProperty('--shoutbox-offset', offset);
    }

    function poll() {
        if (document.hidden) {
            return;
        }

        $.ajax({
            type: 'POST',
            url: config.ajaxUrl,
            data: {
                action: 'shoutbox_get_messages',
                nonce: config.nonce,
                after_id: latestId()
            }
        }).done(function (response) {
            if (!response || !response.success || !response.data || !response.data.messages) {
                return;
            }

            prependMessages(response.data.messages, true);
        });
    }

    function loadMore() {
        if (!loadMoreOn || loadingMore || !$loadMore.length || $loadMore.prop('hidden')) {
            return;
        }

        var before = oldestId();

        if (!before) {
            setLoadMoreVisible(false);
            return;
        }

        loadingMore = true;
        $loadMore.prop('disabled', true).text('Laster...');

        $.ajax({
            type: 'POST',
            url: config.ajaxUrl,
            data: {
                action: 'shoutbox_get_messages',
                nonce: config.nonce,
                before_id: before
            }
        }).done(function (response) {
            if (!response || !response.success || !response.data || !response.data.messages || !response.data.messages.length) {
                setLoadMoreVisible(false);
                return;
            }

            var html = '';

            response.data.messages.forEach(function (item) {
                if (!item || !item.id || $messages.find('[data-message-id="' + item.id + '"]').length) {
                    return;
                }

                html += messageHtml(item);
            });

            if (html) {
                $messages.append(html);
                historyExpanded = true;
                syncOldestId();
            }

            setLoadMoreVisible(!!response.data.has_more);
        }).fail(function () {
            setLoadMoreVisible(true);
        }).always(function () {
            loadingMore = false;
            $loadMore.prop('disabled', false).text('Last mer');
        });
    }

    function sendMessage(event) {
        event.preventDefault();

        if (!$form.length || sending || composeLocked || $send.prop('disabled')) {
            return;
        }

        var message = ($input.val() || '').trim();

        if (!message) {
            return;
        }

        sending = true;
        $send.prop('disabled', true);
        showError('');

        $.ajax({
            type: 'POST',
            url: config.ajaxUrl,
            data: {
                action: 'shoutbox_send_message',
                nonce: config.nonce,
                message: message,
                website_url: $form.find('.shoutbox__honeypot').val() || ''
            }
        }).done(function (response) {
            if (!response || !response.success) {
                var errorData = (response && response.data) ? response.data : {};
                var errorMessage = errorData.message || 'Kunne ikke sende meldingen.';

                if (errorData.blocked) {
                    setComposeLocked(true, errorMessage, errorData.retry_after);
                    return;
                }

                showError(errorMessage);
                return;
            }

            $input.val('');
            updateCounter();
            closeEmoji();

            if (response.data.message) {
                prependMessages([response.data.message], false);
            } else if (response.data.messages) {
                prependMessages(response.data.messages, false);
            }
        }).fail(function (xhr) {
            var payload = xhr.responseJSON && xhr.responseJSON.data ? xhr.responseJSON.data : {};
            var errorMessage = payload.message || 'Kunne ikke sende meldingen.';

            if (xhr.status === 429 || payload.blocked) {
                setComposeLocked(true, errorMessage, payload.retry_after);
                return;
            }

            showError(errorMessage);
        }).always(function () {
            sending = false;

            if (!composeLocked) {
                updateCounter();
            }
        });
    }

    $toggle.on('click', function () {
        setCollapsed(!$root.hasClass('is-collapsed'));
    });

    $input.on('input', updateCounter);

    $input.on('keydown', function (event) {
        if (event.key === 'Enter' && !event.shiftKey) {
            event.preventDefault();
            $form.trigger('submit');
        }
    });

    $form.on('submit', sendMessage);

    $loadMore.on('click', loadMore);

    $emojiToggle.on('click', function (event) {
        event.stopPropagation();

        if (composeLocked) {
            return;
        }
        var open = $emojiPicker.prop('hidden');
        $emojiPicker.prop('hidden', !open);
        $emojiToggle.attr('aria-expanded', open ? 'true' : 'false');
    });

    $root.on('click', '[data-shoutbox-emoji]', function () {
        insertEmoji($(this).attr('data-shoutbox-emoji'));
        closeEmoji();
    });

    $(document).on('click', function (event) {
        if (!$(event.target).closest('.shoutbox__emoji').length) {
            closeEmoji();
        }
    });

    if (typeof mobileQuery.addEventListener === 'function') {
        mobileQuery.addEventListener('change', function () {
            if (!isMobile()) {
                setCollapsed(false);
            }
            updateShoutboxOffset();
        });
    }

    setCollapsed(initialCollapsed());
    updateUnread(unreadFromDom());
    updateCounter();
    updateShoutboxOffset();

    $(window).on('resize', updateShoutboxOffset);

    pollTimer = window.setInterval(poll, config.pollInterval || 8000);

    $(window).on('beforeunload', function () {
        if (pollTimer) {
            window.clearInterval(pollTimer);
        }
    });
});
